// cooperationData.js
const cooperationData = {
  fr: [
    {
      category: "Pianiste pour les artistes et groupes musicaux",
      items: [
        "Chernobilly Boogie",
        "Gaume",
        "Denis Agenet & Nolapsters",
        "Bouskidou",
        "Joey J Saye",
        "Bo Weavil",
        "Skyler Saufley",
        "Tom Holland",
        "Le Bal des Variétistes",
        "Little Tom Band",
        "Nina Kibuanda",
        "Jaywood",
        "Bridgewood Junction",
        "Leo Seeger",
        "Gianna Chillà",
        "Diane K",
        "Savel",
        "Liverpool",
        "Banane Metalik (feat.)",
        "Les Ennuis Commencent (feat.)",
        "Silencers (feat.)",
        "Dïe Morg (feat.)",
        "Elmer Food Beat (feat.)",
        "El Royce (feat.)",
      ],
    },
    {
      category: "Réalisations Studio",
      items: [
        "Silencers",
        "Biche Prod",
        "Leo Seeger",
        "Laurent Deschamps",
        "Ankantry",
        "Anna Simone",
        "Lela Meskhi",
        "Back to the Roots",
        "Little Tom",
        "Didier Gustin",
        "Blanche",
        "Couton et Fischer",
        "Chernobilly Boogie",
        "Cristian Zarate",
        "Lilie Printemps",
        "Petite",
        "Missié Bamboo",
        "Jean-Pierre Souchaire",
        "Pamphile",
        "Patrick Winter",
        "Kimto Vasquez",
        "Tio Feliz Project",
        "Rel Soli",
        "Gaume",
        "Trafic d’Airs",
        "Solstyce",
        "Marango",
        "Beryce",
        "Glenn Gibson",
        "Stan Chris",
        "Jaäg",
        "Jeanne Byl",
        "Jérémie Paul",
        "Jook Joint Company",
        "Echos in the Shed",
        "Suzanne Fischer",
        "Hacienda",
        "Hooplamatic",
        "Stagecoach",
        "Pauline Caron",
      ],
    },
    {
      category: "Pour le Spectacle Vivant",
      items: [
        "Le Collectif Mordu – “La fable de l’Autruche”",
        "Le Collectif Mordu – “Kramazü”",
        "Quelques spectacles avec Bouskidou",
        "Accompagnement des matchs d’impro – La LINA (Ligue d’Impro de Nantes)",
        "“Planète Impro” – Festival Juste Pour Rire",
      ],
    },
    {
      category: "Pratique Amateur",
      items: ["Accompagnement des chanteurs du projet « Trafic d'Airs »"],
    },
    {
      category: "Pour les projets audiovisuels",
      items: [
        "Habillage intégral – Radio Sun",
        "Habillage intégral – EURadio",
        "Musiques pour la télévision internationale – éditées par EMI (Londres)",
        "Musiques pour la télévision internationale – éditées par Cézame (Paris)",
        "Créations musicales occasionnelles – Crescendo Prod",
        "Créations musicales occasionnelles – HéHo",
        "Créations musicales occasionnelles – Gulfstream",
      ],
    },
    {
      category: "Voix off (Anglais et Français)",
      items: [
        "EURadio",
        "Crescendo Prod",
        "Transmedia",
        "Detour Graphic",
        "Ellipsanime",
        "Jack and Me",
      ],
    },
  ],

  en: [
    {
      category: "Pianist for Bands & Artists",
      items: [
        "Chernobilly Boogie",
        "Gaume",
        "Denis Agenet & Nolapsters",
        "Bouskidou",
        "Joey J Saye",
        "Bo Weavil",
        "Skyler Saufley",
        "Tom Holland",
        "Le Bal des Variétistes",
        "Little Tom Band",
        "Nina Kibuanda",
        "Jaywood",
        "Bridgewood Junction",
        "Leo Seeger",
        "Gianna Chillà",
        "Diane K",
        "Savel",
        "Liverpool",
        "Banane Metalik (feat.)",
        "Les Ennuis Commencent (feat.)",
        "Silencers (feat.)",
        "Dïe Morg (feat.)",
        "Elmer Food Beat (feat.)",
        "El Royce (feat.)",
      ],
    },
    {
      category: "Studio Production",
      items: [
        "Silencers",
        "Biche Prod",
        "Leo Seeger",
        "Laurent Deschamps",
        "Ankantry",
        "Anna Simone",
        "Lela Meskhi",
        "Back to the Roots",
        "Little Tom",
        "Didier Gustin",
        "Blanche",
        "Couton et Fischer",
        "Chernobilly Boogie",
        "Cristian Zarate",
        "Lilie Printemps",
        "Petite",
        "Missié Bamboo",
        "Jean-Pierre Souchaire",
        "Pamphile",
        "Patrick Winter",
        "Kimto Vasquez",
        "Tio Feliz Project",
        "Rel Soli",
        "Gaume",
        "Trafic d’Airs",
        "Solstyce",
        "Marango",
        "Beryce",
        "Glenn Gibson",
        "Stan Chris",
        "Jaäg",
        "Jeanne Byl",
        "Jérémie Paul",
        "Jook Joint Company",
        "Echos in the Shed",
        "Suzanne Fischer",
        "Hacienda",
        "Hooplamatic",
        "Stagecoach",
        "Pauline Caron",
      ],
    },
    {
      category: "Theatre and Dance",
      items: [
        "Le Collectif Mordu – “La fable de l’Autruche” (“The Fable of the Ostrich”)",
        "Le Collectif Mordu – “Kramazü”",
        "Several live shows with Bouskidou",
        "Musical accompaniment of improv matches – Lina (The Nantes League of Improv)",
        "“Planète Impro” – Just For Laughs Festival (Nantes)",
      ],
    },
    {
      category: "For Amateurs",
      items: ["Vocal group “Trafic d’Airs“"],
    },
    {
      category: "Audio-visual",
      items: [
        "Complete sound identities – “Sun - Le son unique”",
        "Complete sound identities – “EURadio”",
        "Music for TV – published by EMI (London), Cézame (Paris), distributed internationally",
        "Occasional musical production – Crescendo Prod",
        "Occasional musical production – HéHo",
        "Occasional musical production – Gulfstream",
      ],
    },
    {
      category: "Voice over work (English and French)",
      items: [
        "EURadio",
        "Crescendo Prod",
        "Transmedia",
        "Detour Graphic",
        "Ellipsanime",
        "Jack and Me",
      ],
    },
  ],
};

export default cooperationData;
